import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder,FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-document-control-inquiry',
  templateUrl: './document-control-inquiry.component.html',
  styleUrls: ['./document-control-inquiry.component.scss']
})
export class DocumentControlInquiryComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
  }

  onClick(){
  }
  submitForm(){}
  clearHistory(){}

}
